import { useMutation, useQuery } from 'react-query';
import * as productService from '../services/productService';
import { CreateProductDto } from '../types/dto/CreateProductDto';
import { ListProductsDto } from 'types/dto/ListProductsDto';

export const useCreateProduct = (onSuccess: any, onError: any) => {
  return useMutation(productService.createProduct, {
    onSuccess,
    onError
  });
}

export const useUpdateProductInfo = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductInfo, {
    onSuccess,
    onError
  });
}

export const useUpdateProductCategory = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductCategory, {
    onSuccess,
    onError
  });
}

export const useUpdateProductContents = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductContents, {
    onSuccess,
    onError
  });
}

export const useUpdateProductUsages = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductUsages, {
    onSuccess,
    onError
  });
}

export const useUpdateProductIngredients = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductIngredients, {
    onSuccess,
    onError
  });
}

export const useUpdateProductAttributes = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductAttributes, {
    onSuccess,
    onError
  });
}

export const useRedescribeProduct = (onSuccess: any, onError: any) => {
  return useMutation(productService.redescribeProduct, {
    onSuccess,
    onError
  });
}

export const useReextractProductAttributes = (onSuccess: any, onError: any) => {
  return useMutation(
    ({ productId, withDescription }: { productId: string; withDescription?: boolean }) =>
      productService.reextractProductAttributes(productId, withDescription),
    {
      onSuccess,
      onError
    },
  );
}

export const useReextractProductAttributePart = (onSuccess: any, onError: any) => {
  return useMutation(productService.reextractProductAttributePart, {
    onSuccess,
    onError
  });
}

export const useUpdateProductWarnings = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductWarnings, {
    onSuccess,
    onError
  });
}

export const useUpdateProductRankedIngredients = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductRankedIngredients, {
    onSuccess,
    onError
  });
}

export const useUpdateProductAudience = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductAudience, {
    onSuccess,
    onError
  });
}

export const useUpdateProductBrand = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductBrand, {
    onSuccess,
    onError
  });
}

export const useSetProductAvatarMedia = (onSuccess: any, onError: any) => {
  return useMutation(productService.setProductAvatarMedia, {
    onSuccess,
    onError
  });
}

export const useSetProductDisplayImages = (onSuccess: any, onError: any) => {
  return useMutation(productService.setProductDisplayImages, {
    onSuccess,
    onError
  });
}

export const useUpdateProductLeafCategory = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductLeafCategory, {
    onSuccess,
    onError
  });
}

export const useGetProductByBarcode = (
  barcode: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productByBarcode'],
    queryFn: () => productService.getProductByBarcode(barcode),
    ...options
  });
}

export const useGetProductStatus = (
  barcode: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['productStatus'],
    queryFn: () => productService.getProductStatus(barcode),
    ...options
  });
}

export const useGetProducts = (
  dto: ListProductsDto,
  options = {},
) => {
  return useQuery({
    queryKey: ['products', dto],
    queryFn: () => productService.getProducts(dto),
    keepPreviousData: true,
    ...options,
  })
}

export const useGetProductById = (
  id: string,
  options = {},
) => {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => productService.getProductById(id),
    ...options,
  })
}

export const useDeleteProductImage = (onSuccess: any, onError: any) => {
  return useMutation(productService.deleteProductImage, {
    onSuccess,
    onError
  });
}

export const useUploadProductImages = (onSuccess: any, onError: any) => {
  return useMutation(productService.uploadProductImages, {
    onSuccess,
    onError
  });
}

export const useUpdateProductAvatar = (onSuccess: any, onError: any) => {
  return useMutation(productService.updateProductAvatar, {
    onSuccess,
    onError
  });
}

export const useSyncProductToGraph = (onSuccess: any, onError: any) => {
  return useMutation(productService.syncProductToGraph, {
    onSuccess,
    onError
  });
}

export const usePublishProduct = (onSuccess: any, onError: any) => {
  return useMutation(productService.publishProduct, {
    onSuccess,
    onError
  });
}

export const useUnpublishProduct = (onSuccess: any, onError: any) => {
  return useMutation(productService.unpublishProduct, {
    onSuccess,
    onError
  });
}
